var React = require('react');

function TextAlignLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,0h16v1.8H0V0z M0,16v-1.8h16V16H0z M0,8.9V7.1h16v1.8H0z M10.7,3.5v1.8H0V3.5H10.7z M10.7,10.7v1.8H0v-1.8H10.7z","fill":"currentColor"}));
}

TextAlignLeft.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = TextAlignLeft;

TextAlignLeft.default = TextAlignLeft;
